module.exports = __webpack_public_path__ + "static/media/parent_profile_icon.22471eaf.svg";